import ensureStepCondition from '@root/src/javascripts/helper/stepConditions'
import store from '@root/src/javascripts/store'
// eslint-disable-next-line import/prefer-default-export
export const routes = [
  {
    path: '',
    name: 'InsuranceRequestStart',
    component: () => import('@views/InsuranceRequest/Start'),
    meta: {
      beforeResolve() {
        store.commit('resetNewContractState')
      },
      nextRoute: 'ProductSelect',
    },
  },
  {
    path: 'agent',
    name: 'AgentRequestStart',
    component: () => import('@views/InsuranceRequest/Start'),
    meta: {
      beforeResolve() {
        store.commit('resetNewContractState')
      },
      nextRoute: 'ProductSelect',
    },
  },
  {
    path: 'productSelect',
    name: 'ProductSelect',
    component: () => import('@views/InsuranceRequest/ProductSelect'),
    meta: {
      requiredSteps: ['InsuranceRequestStart'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute: 'InsuranceRequestStart',
      nextRoute: 'Options',
    },
  },
  {
    path: 'options',
    name: 'Options',
    component: () => import('@views/InsuranceRequest/Options'),
    meta: {
      requiredSteps: ['ProductSelect'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute: 'ProductSelect',
      nextRoute: 'VehicleSelect',
    },
  },
  {
    path: 'vehicleSelect',
    name: 'VehicleSelect',
    component: () => import('@views/InsuranceRequest/VehicleSelect'),
    redirect: (nameSuffix) => (_to) => {
      let newRoute
      if (store.state.newContract.vehicle.id !== null) {
        newRoute = 'VehicleSelected'
      } else if (store.state.newContract.searchmode !== 'comfort') {
        newRoute = 'VehicleSelectVehicleNumber'
      } else {
        newRoute = 'VehicleSelectComfort'
      }
      return {
        name: `${newRoute}${nameSuffix}`,
      }
    },
    meta: {
      requiredSteps: ['ProductSelect', 'Options'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      // No tracking id to track redirectd routes
    },
  },
  {
    path: 'vehicleSelect/vehicleSelectComfort',
    name: 'VehicleSelectComfort',
    component: () => import('@views/InsuranceRequest/VehicleSelect/Comfort'),
    meta: {
      requiredSteps: ['ProductSelect', 'Options'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute() {
        return store.state.newContract.customized ? 'Options' : 'ProductSelect'
      },
      nextRoute: 'VehicleData',
    },
  },
  {
    path: 'vehicleSelect/vehicleSelectVehicleNumber',
    name: 'VehicleSelectVehicleNumber',
    component: () => import('@views/InsuranceRequest/VehicleSelect/VehicleNumber'),
    meta: {
      requiredSteps: ['ProductSelect', 'Options'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute() {
        if (store.state.newContract.vehicle.id === null) {
          return 'VehicleSelectVehicleNumber'
        }
        return store.state.newContract.customized ? 'Options' : 'ProductSelect'
      },
      nextRoute: 'VehicleData',
    },
  },
  {
    path: 'vehicleSelected',
    name: 'VehicleSelected',
    component: () => import('@views/InsuranceRequest/VehicleSelect/Selected'),
    meta: {
      requiredSteps: ['ProductSelect', 'Options', 'VehicleSelect'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute() {
        return store.state.newContract.customized ? 'Options' : 'ProductSelect'
      },
      nextRoute: 'VehicleData',
    },
  },
  {
    path: 'vehicleData',
    name: 'VehicleData',
    component: () => import('@views/InsuranceRequest/VehicleData'),
    meta: {
      requiredSteps: ['ProductSelect', 'Options', 'VehicleSelect'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute: 'VehicleSelect',
      nextRoute: 'Owner',
    },
  },
  {
    path: 'owner',
    name: 'Owner',
    component: () => import('@views/InsuranceRequest/Owner'),
    meta: {
      requiredSteps: ['VehicleData'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute: 'VehicleData',
      nextRoute: 'PersonalData',
    },
  },
  {
    path: 'personalData',
    name: 'PersonalData',
    component: () => import('@views/InsuranceRequest/PersonalData'),
    meta: {
      requiredSteps: ['Owner'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute: 'Owner',
      nextRoute: 'Checkout',
    },
  },
  {
    path: 'checkout',
    name: 'Checkout',
    component: () => import('@views/InsuranceRequest/Checkout'),
    meta: {
      requiredSteps: ['PersonalData'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
      previousRoute: 'PersonalData',
      nextRoute: 'Confirmation',
    },
  },
  {
    path: 'offer',
    name: 'Offer',
    component: () => import('@views/InsuranceRequest/Offer'),
    meta: {
      previousRoute: 'Checkout',
      nextRoute: 'Confirmation',
    },
  },
  {
    path: 'referral/:token/:contractid',
    name: 'Referral',
    component: () => import('@views/InsuranceRequest/Referral'),
  },
  {
    path: 'referral/:token/:contractid/agent',
    name: 'ReferralAgent',
    component: () => import('@views/InsuranceRequest/Referral'),
    redirect: {
      name: 'Referral',
    },
  },
  {
    path: 'confirmation/:token/:contractid',
    name: 'ReferralConfirmation',
    component: () => import('@views/InsuranceRequest/Referral'),
    redirect: {
      name: 'Referral',
    },
  },
  {
    path: 'confirmation',
    name: 'Confirmation',
    component: () => import('@views/InsuranceRequest/Confirmation'),
    meta: {
      nextRoute: 'Finish',
    },
  },
  {
    path: 'infoLater',
    name: 'InfoLater',
    component: () => import('@views/InsuranceRequest/InfoLater'),
    meta: {
      requiredSteps: ['Confirmation'],
      beforeResolve() {
        return ensureStepCondition(this.requiredSteps)
      },
    },
  },
  {
    path: 'finish',
    name: 'Finish',
    component: () => import('@views/InsuranceRequest/Finish'),
  },
  {
    path: 'declined',
    name: 'Declined',
    component: () => import('@views/InsuranceRequest/Declined'),
  },
  {
    path: 'rejected',
    name: 'Rejected',
    component: () => import('@views/InsuranceRequest/Rejected'),
  },
  {
    path: 'offerExpired',
    name: 'OfferExpired',
    component: () => import('@views/InsuranceRequest/OfferExpired'),
  },
  {
    path: 'error',
    name: 'Error',
    component: () => import('@views/InsuranceRequest/Error'),
  },
]
